import Events from "@wwdev/bootstrap/Events";

class Select2Component {
	constructor() {
		this.fixFocusOnSearchField();

		Events.on('wwdev::select2::init', () =>{
			$('.select2').each( (it, el) => {
				this.initComponent(el);
			});
		});

		Events.trigger('wwdev::select2::init');
	}

	fixFocusOnSearchField() {
		$(document).on('select2:open', () => {
			document.querySelector('.select2-search__field').focus();
		});
	}

	initComponent(HtmlElement) {
		let $element = $(HtmlElement);
		let options = $element.data('config');
		$element.select2(options);
	}
}

export default Select2Component;